import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppService } from "../../core/services/app.service";

@Injectable({
  providedIn: "root",
})
export class TravelKitService {
  constructor(public http: HttpClient) {}

  getTravelKitByGroupId(id) {
    return this.http.get(AppService.getApiUrl() + "/api/digitalMemoryLogs/" + id);
  }

  saveTravelKit(id, data) {
    return this.http.put(AppService.getApiUrl() + "/api/digitalMemoryLogs/" + id, data);
  }

  submitTravelKit(id, data) {
    return this.http.post(AppService.getApiUrl() + "/api/digitalMemoryLogs", data);
  }

  createCourse(courseModel) {
    return this.http.post(AppService.getApiUrl() + "/api/courses", courseModel);
  }

  updateCourse(courseModel, id) {
    return this.http.put(AppService.getApiUrl() + "/api/courses/" + id, courseModel);
  }

  deleteCourse(id) {
    return this.http.delete(AppService.getApiUrl() + "/api/courses/" + id);
  }

  createRecommendation(recommendationModel) {
    return this.http.post(AppService.getApiUrl() + "/api/recommendations", recommendationModel);
  }

  updateRecommendation(recommendationModel, id) {
    return this.http.put(AppService.getApiUrl() + "/api/recommendations/" + id, recommendationModel);
  }

  deleteRecommendation(id) {
    return this.http.delete(AppService.getApiUrl() + "/api/recommendations/" + id);
  }

  createChapter(chapterModel) {
    return this.http.post(AppService.getApiUrl() + "/api/courseChapters", chapterModel);
  }

  updateChapter(chapterModel, id) {
    return this.http.put(AppService.getApiUrl() + "/api/courseChapters/" + id, chapterModel);
  }

  deleteChapter(id) {
    return this.http.delete(AppService.getApiUrl() + "/api/courseChapters/" + id);
  }

  createWallpaper(wallpaperModel) {
    return this.http.post(AppService.getApiUrl() + "/api/wallpapers", wallpaperModel);
  }

  updateWallpaper(wallpaperModel, id) {
    return this.http.put(AppService.getApiUrl() + "/api/wallpapers/" + id, wallpaperModel);
  }

  deleteWallpaper(id) {
    return this.http.delete(AppService.getApiUrl() + "/api/wallpapers/" + id);
  }
  getTravelKitByClub(club) {
    return this.http.get(AppService.getApiUrl() + "/api/TravelKits/share?groupId=" + club);
  }

  createSection(sectionData) {
    return this.http.post(AppService.getApiUrl() + "/api/sections", sectionData);
  }
  updateSection(sectionData) {
    return this.http.put(AppService.getApiUrl() + "/api/sections/" + sectionData.id, sectionData);
  }
  createSubSection(sectionData) {
    return this.http.post(AppService.getApiUrl() + "/api/subSections", sectionData);
  }

  updateSubSection(sectionData) {
    return this.http.put(AppService.getApiUrl() + "/api/subSections/" + sectionData.id, sectionData);
  }
  createMedia(media) {
    return this.http.post(AppService.getApiUrl() + "/api/medias", media);
  }

  updateMedia(media, id) {
    return this.http.put(AppService.getApiUrl() + "/api/medias/" + id, media);
  }

  deleteMedia(ids) {
    return this.http.delete(AppService.getApiUrl() + "/api/medias/" + ids);
  }

  deleteSection(ids) {
    const sectionIdsParam = JSON.stringify({ ids: ids });
    return this.http.delete(
      AppService.getApiUrl() + "/api/sections/deleteSections/?sectionIds=" + encodeURIComponent(sectionIdsParam)
    );
  }
  deleteSubSection(ids) {
    const subSectionIdsParam = JSON.stringify({ ids: ids });
    return this.http.delete(
      AppService.getApiUrl() +
        "/api/subSections/deleteSubSections/?subSectionIds=" +
        encodeURIComponent(subSectionIdsParam)
    );
  }
}
